var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.05,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.94 0c5 0 13.13 0 17.63 1.46 5.59 1.7 9.48 6.08 9.48 12.16 0 14-12.64 21.27-46.68 29.66V64.8c0 8.51 2.43 12.2 7.41 12.2v3H0v-3c5 0 6.44-3.65 6.44-12.16V15.2C6.44 6.69 5 3 0 3V0zM31.37 34.41c8.27-1.83 20.91-6.81 20.91-16.78 0-7-6.08-9.6-12.28-9.6-8.27 0-8.63 3.16-8.63 10.21z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3OC4wNSIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDc4LjA1IDgwIj4KICA8cGF0aCBkPSJNNTAuOTQsMGM1LDAsMTMuMTMsMCwxNy42MywxLjQ2LDUuNTksMS43LDkuNDgsNi4wOCw5LjQ4LDEyLjE2LDAsMTQtMTIuNjQsMjEuMjctNDYuNjgsMjkuNjZWNjQuOEMzMS4zNyw3My4zMSwzMy44LDc3LDM4Ljc4LDc3djNIMFY3N2M1LDAsNi40NC0zLjY1LDYuNDQtMTIuMTZWMTUuMkM2LjQ0LDYuNjksNSwzLDAsM1YwWk0zMS4zNywzNC40MWM4LjI3LTEuODMsMjAuOTEtNi44MSwyMC45MS0xNi43OCwwLTctNi4wOC05LjYtMTIuMjgtOS42LTguMjcsMC04LjYzLDMuMTYtOC42MywxMC4yMVoiIGZpbGw9IiNlOGZmYTIiLz4KPC9zdmc+Cg==";
export { SvgLetterP as ReactComponent };